module.exports = __webpack_public_path__ + "img/foto_entree.ba737815.jpg";